"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModerationStatusResponseModel = void 0;
const core = __importStar(require("../../core"));
const ModerationStatusResponseModelSafetyStatus_1 = require("./ModerationStatusResponseModelSafetyStatus");
const ModerationStatusResponseModelWarningStatus_1 = require("./ModerationStatusResponseModelWarningStatus");
exports.ModerationStatusResponseModel = core.serialization.object({
    isInProbation: core.serialization.property("is_in_probation", core.serialization.boolean()),
    enterpriseCheckNogoVoice: core.serialization.property("enterprise_check_nogo_voice", core.serialization.boolean()),
    enterpriseCheckBlockNogoVoice: core.serialization.property("enterprise_check_block_nogo_voice", core.serialization.boolean()),
    neverLiveModerate: core.serialization.property("never_live_moderate", core.serialization.boolean()),
    nogoVoiceSimilarVoiceUploadCount: core.serialization.property("nogo_voice_similar_voice_upload_count", core.serialization.number()),
    enterpriseBackgroundModerationEnabled: core.serialization.property("enterprise_background_moderation_enabled", core.serialization.boolean()),
    safetyStatus: core.serialization.property("safety_status", ModerationStatusResponseModelSafetyStatus_1.ModerationStatusResponseModelSafetyStatus.optional()),
    warningStatus: core.serialization.property("warning_status", ModerationStatusResponseModelWarningStatus_1.ModerationStatusResponseModelWarningStatus.optional()),
    onWatchlist: core.serialization.property("on_watchlist", core.serialization.boolean()),
});
